import { pick } from 'lodash';
import type { ReadonlyDeep } from 'type-fest';

import type { MemosState } from '..';

export function memoForm2ApiMapper(
  memo: ReadonlyDeep<MemosState>,
): ReadonlyDeep<Pick<MemosState, 'internalMemo' | 'memo'>> {
  return pick(memo, 'internalMemo', 'memo');
}
